module.exports = __webpack_public_path__ + "static/media/ISO_9001_SWASTA.98afd8e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ISO_9001_SWASTA.jpg
// module id = 1592
// module chunks = 0